module.exports = __webpack_public_path__ + "static/media/blocker_nothing.5b2641fe.png";